import React from 'react';
import { useCurrentAccountId } from '@zapier/identity';
import { SplitFactory } from '@splitsoftware/splitio-react';

type Props = {
  children: any;
};

export const SplitIOProvider = ({ children }: Props) => {
  const accountId = useCurrentAccountId();
  const isProduction =
    typeof window !== 'undefined' &&
    window.location?.hostname?.includes('zapier.com');
  const authorizationKey = isProduction
    ? 'mctu4q1tvfa8hgn8kgt5doe0ev6h68th135'
    : 'er39tqoto8kar2h0n7dkdvc85p3bcubnt5so';
  return (
    <SplitFactory
      config={{
        core: {
          authorizationKey,
          key: accountId,
        },
      }}
      updateOnSdkUpdate={true}
    >
      {children}
    </SplitFactory>
  );
};
